module.exports = __webpack_public_path__ + "static/assets/f028561572bcd32f3bac9970ecd236fa.svg";